import { render, staticRenderFns } from "./HomeBeneficios.vue?vue&type=template&id=1b634005&scoped=true&"
import script from "./HomeBeneficios.vue?vue&type=script&lang=ts&"
export * from "./HomeBeneficios.vue?vue&type=script&lang=ts&"
import style0 from "./HomeBeneficios.vue?vue&type=style&index=0&id=1b634005&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b634005",
  null
  
)

export default component.exports